/**
 * @fileoverview Pure pagination helpers shared by catalog pagination and view-model code.
 * @module hooks/companyCatalog/companyCatalogPaginationUtils
 */

/**
 * @param {number} companiesLength Number of catalog rows currently loaded in memory
 * @param {number} resultsLimit Selected page size from the catalog toolbar
 * @returns {number} Number of full pages available from the loaded rows
 */
export const getLoadedPagesCount = (companiesLength, resultsLimit) =>
  Math.max(1, Math.ceil(companiesLength / resultsLimit));

/**
 * @param {number} loadedPages Pages already available from cached rows
 * @param {string|null} lastKey DynamoDB cursor indicating more remote pages exist
 * @param {boolean} limitReached Whether the catalog has exhausted remote pagination
 * @returns {number} Total pages shown by the catalog pager control
 */
export const getTotalPages = (loadedPages, lastKey, limitReached) =>
  lastKey && !limitReached ? loadedPages + 1 : loadedPages;

/**
 * @param {number} currentPage Active 1-based page index
 * @param {number} companiesLength Number of catalog rows currently loaded in memory
 * @param {number} resultsLimit Selected page size from the catalog toolbar
 * @returns {boolean} True when the next page can be served from cached rows alone
 */
export const canAdvanceLocalPage = (
  currentPage,
  companiesLength,
  resultsLimit,
) => currentPage < Math.ceil(companiesLength / resultsLimit);
